module.exports = __webpack_public_path__ + "media/sound.f575d1d2.mp3";